export interface Boundaries {
    opening: string;
    closing: string;
}

export interface Args<T> {
    boundaries: Boundaries;
    text: string;
    defaultSegmentWrapper: (text: string) => T;
    boundedSegmentWrapper: (text: string) => T;
}

export function segmentTextByBoundaries<T>({
    boundaries,
    text,
    defaultSegmentWrapper,
    boundedSegmentWrapper,
}: Args<T>): T[] {
    const parts: T[] = [];
    let position = 0;

    if (!text) {
        return [];
    }

    while (position < text.length) {
        const startIndex = text.indexOf(boundaries.opening, position);
        const endIndex = text.indexOf(boundaries.closing, startIndex + boundaries.opening.length);

        if (startIndex === -1 || endIndex === -1) {
            parts.push(defaultSegmentWrapper(text.substring(position)));
            position = text.length;
        } else {
            const wrappedText = text.substring(startIndex + boundaries.opening.length, endIndex);
            parts.push(
                defaultSegmentWrapper(text.substring(position, startIndex)),
                boundedSegmentWrapper(wrappedText),
            );
            position = endIndex + boundaries.closing.length;
        }
    }

    return parts;
}
